import type { Transaction } from "@rocicorp/zero";
import { type Schema, zql } from "./generatedDrizzleSchema";

export async function isFeatureFlagEnabled(
  tx: Transaction<Schema>,
  name: string,
  tenantId: string
): Promise<boolean> {
  const rows = await tx.run(
    zql.featureFlags
      .where("name", "=", name)
      .where("enabledAt", "IS NOT", null)
      .where("tenantId", tenantId)
  );
  return rows.length > 0;
}
